class PyRegExResult {
  constructor (pyregex, result) {
    this.pyregex = pyregex
    this.result = result
  }
  _gindex(key) {
    switch (typeof(key)) {
    case 'number': return key
    case 'string': return 1+this.pyregex.groupNames.indexOf(key)
    case 'undefined': return 0
    }
  }
  group (key) { return this.result[this._gindex(key)] }
  end (key) {
    if (this._gindex(key) !== 0)
      throw new Error('Unsupported argument for end()')
    return this.result.index + this.result[0].length
  }
}

export default class PyRegEx {
  constructor (regex, groupNames) {
    this.regex = regex
    if (typeof(groupNames) === 'string')
      groupNames = groupNames.split(',')
    this.groupNames = groupNames
  }
  search(str, pos, endpos) {
    this.regex.lastIndex = pos || 0
    let rv = this.regex.exec(str)
    if (rv === null)
      return null
    if (typeof(endpos) !== 'undefined' && rv.index + rv[0].length > endpos)
      return null
    return new PyRegExResult(this, rv)
  }
  match(str, pos, endpos) {
    let rv = this.search(...arguments)
    if (rv && rv.result.index !== (pos || 0))
      return null
    return rv
  }
}
